export const HIDE_ALL = 'HIDE_ALL';
export const COPY_LINK = 'COPY_LINK';
export const MANAGE_LINK = 'MANAGE_LINK';
export const DELETE_LINK = 'DELETE_LINK';
export const DELETE_SELECTED_LINKS = 'DELETE_SELECTED_LINKS';
